import { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { AuthContext } from '../../contexts/Auth'
import { notificador } from '../../helpers'
import { toast } from 'react-toastify'
import Organizacao from '../../middleware/Organizacao'
import io from 'socket.io-client'
import MenuDashboard from '../MenuOpcoesDashboard'
import MenuTarefas from '../MenuOpcoesTarefas'
import MenuAtendimento from '../MenuOpcoesAtendimento'
import MenuProcessos from '../MenuOpcoesProcessos'
import MenuCadastros from '../MenuOpcoesCadastros'
import MenuDocumentosDigitais from '../MenuOpcoesDocumentosDigitais'
import MenuRecrutamento from '../MenuOpcoesRecrutamento'
import MenuFinanceiro from '../MenuOpcoesFinanceiro'
import MenuRelatorio from '../MenuOpcoesRelatorios'
import MenuGesttor from '../MenuOpcoesGesttor'
import MenuSuporte from '../MenuOpcoesSuporte'
import MenuConfiguracao from '../MenuOpcoesConfiguracoes'
import ModalMeuPerfil from '../ModalMeuPerfil'
import ModalAssinatura from '../ModalAssinatura'
import ModalAtualizarAvatarUsuario from '../ModalAtualizarAvatarUsuario'
import dashboardIcone from '../../assets/icons/dashboard.svg'
import tarefasIcone from '../../assets/icons/tarefas.svg'
import processosIcone from '../../assets/icons/processos.svg'
import cadastrosIcnoe from '../../assets/icons/cadastros.svg'
import documentosDigitais from '../../assets/icons/documentosDigitais.svg'
import recrutamento from '../../assets/img/recrutamento.png'
import financeiroIcone from '../../assets/icons/financeiro.svg'
import relatorioIcone from '../../assets/icons/relatorios.svg'
import gesttorIcone from '../../assets/img/icone.png'
import suporteImg from '../../assets/icons/suporte.svg'
import configuracaoImg from '../../assets/icons/configuracoes.svg'
import avatarDefault from '../../assets/img/avatarDefault.png'
import avatarOrganizacaoDefault from '../../assets/img/organizacao.png'
import logoImg from '../../assets/img/logo.png'
import logoIcone from '../../assets/img/icone.png'
import ModulosContratados from '../../middleware/SistemasContratados'
import MenuOpcoesProjetos from '../MenuOpcoesProjetos'
import Permissoes from '../../middleware/Permissoes'
import MenuOpcoesConquistas from '../MenuOpcoesConquistas'
import './menulateral.css'

function MenuLateral() {

    const navigate = useNavigate()

    const { modalExibir, exibirModalSecundario, modalEstadoSecundario, modal } = useContext(ModalEstadoContext)
    const { isAuth } = useContext(AuthContext)


    const [avatar, setAvatar] = useState('')
    const [avatarOrganizacao, setAvatarOrganizacao] = useState('')
    const [dadosUsuario, setDadosUsuario] = useState(false)
    const [modalPerfil, setModalPerfil] = useState(false)

    const exibirDadosUsuario = () => setDadosUsuario(!dadosUsuario)

    const exibirModalPerfil = () => exibirModalSecundario()

    const atualizarAvatarUsuario = () => {

        return modalExibir('atualizarAvatarUsuario')
    }

    const home = () => navigate('/painel')

    const sair = () => {

        localStorage.clear();
        document.cookie = 'authGesttor= ; expires=true, 01 Jan 2023 00:00:01 GMT'
        document.cookie = 'modulosGesttor= ; expires=true, 01 Jan 2023 00:00:01 GMT'

        isAuth()

        return navigate('/')
    }


    useEffect(() => {
        setModalPerfil(modalEstadoSecundario)
    }, [modalEstadoSecundario])


    useEffect(() => {

        const avatar = () => {

            const avatarImg = localStorage.getItem('usuarioGesttorAvatar')

            if (avatarImg === 'null' || avatarImg === null) {

                return setAvatar(avatarDefault)
            }

            return setAvatar(avatarImg)
        }

        avatar()
    }, [])

    useEffect(() => {

        const avatarOrganizacao = () => {

            const avatarOrganizacaoImg = localStorage.getItem('organizacaoGesttorAvatar')

            if (avatarOrganizacaoImg === 'null' || avatarOrganizacaoImg === null) {

                return setAvatarOrganizacao(avatarOrganizacaoDefault)
            }

            return setAvatarOrganizacao(avatarOrganizacaoImg)
        }

        avatarOrganizacao()

    }, [])

    useEffect(() => {


        const iniciarSocket = () => {

            const idOrganizacao = localStorage.getItem("organizacaoGesttor")

            const socket = io(`${process.env.REACT_APP_API_GESTTOR}?idOrganizacao=${idOrganizacao}`)

            socket.on('connect', () => {
                socket.emit('salaOrganizacao', idOrganizacao)
            })


            socket.on('notificacaoUsuario', async (data) => {

                const { nome, icone } = data

                toast.success(`${nome} está on-line`, {
                    icon: <img src={icone} alt="Ícone" style={{ width: 24, height: 24, borderRadius: 50 }} />
                })

                const dadosNotificacao = {
                    body: `${nome} está on-line`
                }

                await notificador.notificacao(dadosNotificacao)
                notificador.reproduzirAudio()

            })

            return () => {
                socket.disconnect()
            }

        }

        iniciarSocket()

    }, [])

    return (
        <>
            {modalPerfil && <ModalMeuPerfil />}
            {modal.nome === 'atualizarAvatarUsuario' && <ModalAtualizarAvatarUsuario />}
            <aside id='menuLateral'>
                {modal.nome === 'minhaAssinatura' && <ModalAssinatura />}
                <section id='logoGesttor'>
                    <img id='logoSistemaGesttorMenuLateralExpandido' src={logoImg} alt='logo do sistema gesttor' onClick={() => home()} />
                    <img id='logoSistemaGesttorMenuLateralRecolhido' src={logoIcone} alt='logo do sistema gesttor' onClick={() => home()} />
                </section >
                <section id='menuLateralOpcoes'>
                    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'suporte', 'consultor', 'desenvolvedor', 'dashboard_acesso']}>
                        <MenuDashboard icone={dashboardIcone} titulo='Dashboard' alt='' />
                    </Permissoes>
                    <ModulosContratados modulo={["Atendimento"]}>
                        <Permissoes permissoes={['master', 'administrativo' ,'atendimento', 'atendimento_acesso']}>
                            <MenuAtendimento icone={""} titulo='Atendimento' alt='' />
                        </Permissoes>
                    </ModulosContratados>
                    <MenuTarefas icone={tarefasIcone} titulo='Tarefas' alt='' />
                    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'consultor', 'suporte', 'processo_acesso']}>
                        <MenuProcessos icone={processosIcone} titulo='Processos' alt='' />
                    </Permissoes>
                    <ModulosContratados modulo={["Recrutamento"]}>
                        <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'recrutamento_acesso']}>
                            <MenuRecrutamento icone={recrutamento} titulo='Recrutamento' alt='' />
                        </Permissoes>
                    </ModulosContratados>
                    <ModulosContratados modulo={["Projetos"]}>
                        <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'consultor', 'desenvolvedor', 'projeto_acesso']}>
                            <MenuOpcoesProjetos icone={""} titulo='Projetos' alt='' />
                        </Permissoes>
                    </ModulosContratados>
                    <ModulosContratados modulo={["Documentos"]}>
                        <Permissoes permissoes={['master', 'administrativo', 'doc_acesso']}>
                            <MenuDocumentosDigitais icone={documentosDigitais} titulo='Documentos' alt='' />
                        </Permissoes>
                    </ModulosContratados>
                    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'cadastro_acesso']}>
                        <MenuCadastros icone={cadastrosIcnoe} titulo='Cadastros' alt='' />
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_acesso']}>
                        <MenuFinanceiro icone={financeiroIcone} titulo='Financeiro' alt='' />
                    </Permissoes>
                    <Permissoes permissoes={['master', 'relatorio_acesso']}>
                        <MenuRelatorio icone={relatorioIcone} titulo='Relatórios' alt='' />
                    </Permissoes>
                    <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
                        <Permissoes permissoes={['master', 'conquistas_acesso']}>
                            <MenuOpcoesConquistas icone={relatorioIcone} titulo='Conquistas' alt='' />
                        </Permissoes>
                    </Organizacao>
                    <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
                        <Permissoes permissoes={['master', 'administrativo', 'suporte', 'desenvolvedor', 'gesttor_acesso']}>
                            <MenuGesttor icone={gesttorIcone} titulo='Gesttor' alt='' />
                        </Permissoes>
                    </Organizacao>
                    <MenuSuporte icone={suporteImg} titulo='Suporte' alt='' />
                    <Permissoes permissoes={['master', 'administrativo', 'configuracao_acesso']}>
                        <MenuConfiguracao icone={configuracaoImg} titulo='Configurações' alt='' />
                    </Permissoes>
                </section>
                <section id='contaUsuarioMenu'>
                    <img id='avatarUsuarioGesttor' src={avatar} alt='' onClick={exibirDadosUsuario} />
                    <img id='avatarOrganizacaoGesttor' src={avatarOrganizacao} alt='' title='Empresa que você está trabalhando atualmente' />
                    <p onClick={exibirDadosUsuario}>Minha Conta</p>
                    {dadosUsuario && <span id='dadosUsarioMenulateral'>
                        <p onClick={() => exibirModalPerfil()}>Meu Perfil</p>
                        <p onClick={() => atualizarAvatarUsuario()}>Atualizar Avatar</p>
                        <p onClick={sair}>Sair</p>
                    </span>}
                </section>
            </aside>
        </>
    )
}

export default MenuLateral